var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(Object.assign({}, _vm.wrapStyle,_vm.bgImageStyle)),on:{"click":_vm.invite}})}
var staticRenderFns = []

export { render, staticRenderFns }